exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".asda-link{font-size:16px;letter-spacing:.2px;line-height:20px;font-weight:600;text-decoration:none}.asda-link--primary{color:#0073b1}.asda-link--primary:focus,.asda-link--primary:hover,.asda-link--secondary{text-decoration:underline}.asda-link--secondary{color:#3d3d3d}.asda-link--disabled,.asda-link:disabled{color:#767676;pointer-events:none}.asda-link--button{background:none;border:none;padding:0;outline:0}.asda-link--standalone{display:inline-block;padding:8px 16px}.asda-link--align-left{padding-left:0}.asda-link--align-right{padding-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./common/components/link/_style.scss
// module id = 758
// module chunks = 0